import '../../scss/style.scss';
// import '/node_modules/react-grid-layout/css/styles.css'
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { PageRouter } from '../components/router';
import { BrowserRouter as Router } from 'react-router-dom';
ReactDOM.render(React.createElement(Router, null,
    React.createElement(PageRouter, null)), document.getElementById('root'));
